import { render, staticRenderFns } from "./releaseApply.vue?vue&type=template&id=26ded978&scoped=true&"
import script from "./releaseApply.vue?vue&type=script&lang=js&"
export * from "./releaseApply.vue?vue&type=script&lang=js&"
import style0 from "./releaseApply.vue?vue&type=style&index=0&id=26ded978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ded978",
  null
  
)

export default component.exports